module.exports = __webpack_public_path__ + "img/6.75d94c01.jpg";